module.exports = __webpack_public_path__ + "img/g_huang.aed6ed40.png";